module.exports = __webpack_public_path__ + "img/receipt.98c53874.svg";